import {useEffect,useState,useCallback} from 'react';
import {makeStyles } from '@material-ui/core/styles';
import DashboardHeader from '../common/dashboardHeader.js';
import {Grid, Typography, Chip, Button, Tooltip, CircularProgress} from '@material-ui/core';
import {useLocation,useParams} from 'react-router-dom';
import {
    api,
    editorContent,
    BRIEFS_UTIL,
    triggerTopicClusters,
    triggerQuestionClusters
} from '../../utility';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import TopicDetail from './topicDetail.js';
import Drawer from '@material-ui/core/Drawer';
import Debounce from 'lodash.debounce';
import TopicBrief from './topic';
import QuestionsBrief from './questions';
import OutlineBrief from './outline';
import { Line } from 'rc-progress';
import * as briefActions from '../../actions/briefActions';
import {useSelector, useDispatch} from 'react-redux';
import BriefCompletionButton from './briefCompletionButton.js';
import topic_lodash from 'lodash';
import store from 'store';

const useStyleTab = makeStyles((theme) => ({
    root: {
      color: theme.palette.common.black,
      border:'unset!important',
    },
    selected: {
        color: theme.palette.common.black+'!important',
        backgroundColor: theme.palette.common.white+'!important',
        border:'unset!important',
        borderBottomLeftRadius: '0!important',
        borderBottomRightRadius: '0!important'
    },
  }));

function Brief(props){
    const tabClasses = useStyleTab();
    const location = useLocation();
    const dispatch = useDispatch();
    let { id } = useParams();
    const [viewState, setViewState] = useState("topic");
    const [content, setContent] = useState([]);
    const [headingsSideBar, setHeadingsSideBar] = useState(false);
    const [selectedTopic, setSelectedTopic] = useState({});
    const latestContent = editorContent();
    const [showUnused, setShowUnused] = React.useState(false);
    const [topicClusteringSwitch, setTopicClusteringSwitch] = React.useState(false);
    const [questionsClusteringSwitch,setQuestionsClusteringSwitch] = React.useState(false);
    const [topicClustering, setTopicClustering] = useState(false);
    const [questionsClustering, setQuestionsClustering] = useState(false);
    const [clusteringLoadingState, setClusteringLoadingState] = useState(false);
    const loggedInState = useSelector(state => state.auth);
    const activeBrief = useSelector(state => state.briefs.activeBrief);

    const grade = topic_lodash.get(activeBrief, 'content_gdocs.grade') || "";
    const wordCount = topic_lodash.get(activeBrief, 'content_gdocs.word_count') || 0;
    const nextGradeCount = topic_lodash.get(activeBrief, 'content_gdocs.topics_for_next_grade') || 0;
    const topics = topic_lodash.get(activeBrief, 'report.recommended_topics') || [];
    const topicName = topic_lodash.get(activeBrief, 'name') || "";

    const setUpdatedContent = useCallback(Debounce((value,content) => {
        console.log('setting content');
        if(value.toString() != content.toString()) {
            setContent(value);
        }
    }, 500),[]);

    const fetchReport = () =>{
        return new Promise(function(resolve, reject){
            dispatch(briefActions.getActiveBrief(id)).then((data) => {
                resolve(data);
            }). catch((error) => {
                reject(error);
            });
        });
    }

    const updateContentCall = () => {
        if(content && content.length > 0){
            dispatch(briefActions.updateActiveBriefContent(id, content));
        }
    }

    const handleViewChange = (value) => {
        if(value){
            setViewState(value);    
        }
    }

    useEffect(()=>{
       fetchReport();
       window.AP.tanalytics.track('Brief Loaded', {brief: api.GET_BASE_URL('TOPIC_BASE_URL')+api.GET_BRIEFS+`${id}`});
    },[]);

    useEffect(()=>{
        updateContentCall();
    },[content]);

    useEffect(()=>{
        if(topicClusteringSwitch && !topicClustering){
            // Check if the clustering is already in the topics, Then skip this part and go directly to sorting
            if(!topic_lodash.isEmpty(topics) && topic_lodash.isNumber(topics[0].cluster)){
                setTopicClustering(true);
            }else{
                setClusteringLoadingState(true);
                triggerTopicClusters(id, () => {
                    fetchReport().then(() => {
                        setTopicClustering(true);
                        setClusteringLoadingState(false);
                        updateContentCall();
                    });
                    
                }, () => {
                    props.openSnackbar(BRIEFS_UTIL.TOPIC_CLUSTERING_TEXT_ERROR);
                    setClusteringLoadingState(false);
                });
            }
        }
    },[topicClusteringSwitch])

    useEffect(()=>{
        if(questionsClusteringSwitch && !questionsClustering){

            const getQuestionArray = (q) => {
                if(!topic_lodash.isEmpty(q) && topic_lodash.isArray(q.questions) && !topic_lodash.isEmpty(q.questions)){
                  return q.questions;
                } else{
                  return [];
                }
            }

            let {related_questions_quora, related_questions_autocomplete, related_questions} = activeBrief.report;
            let quora_questions = getQuestionArray(related_questions_quora);
            let autocomplete_questions = getQuestionArray(related_questions_autocomplete);
            let questions = getQuestionArray(related_questions);

            const all_questions = quora_questions.concat(autocomplete_questions).concat(questions);
            const enableSortingToggle = !topic_lodash.isEmpty(all_questions) && topic_lodash.isNumber(all_questions[0].cluster);
            if(enableSortingToggle){
                setQuestionsClustering(true);
            }else{
                setClusteringLoadingState(true);
                triggerQuestionClusters(id, () => {
                    fetchReport().then(() => {
                        setQuestionsClustering(true);
                        setClusteringLoadingState(false);
                        updateContentCall();
                    });
                }, () => {
                    props.openSnackbar(BRIEFS_UTIL.QUESTIONS_CLUSTERING_TEXT_ERROR);
                    setClusteringLoadingState(false);
                });
            }
        }
    },[questionsClusteringSwitch])


    if(window.isClassicEditor){
        useEffect(() =>{
            // Run just once when we mount, To make sure the initial grading is done.
            if(topics.length > 0){
                setUpdatedContent(editorContent(),content);
            }
        },[topics])
        
        useEffect(()=>{
            // To make sure in classic editor the content is fecthed smoothly and consistenly
            // On Keyup Event
            tinymce.activeEditor.on('keyup', () => {
                // console.log('change', topics.length);
                if(topics.length > 0){
                    setUpdatedContent(editorContent(),content);
                }
            });

            //Cleanup
            return function cleanup(){
                tinymce.activeEditor.off('keyup');
            }
        });
    } else{
        useEffect(()=>{
            if(topics && topics.length > 0){
                setUpdatedContent(latestContent,content);
            }
        },[latestContent]);
    }

    const viewHeadings = (topic) => {
        setSelectedTopic(topic);
        setHeadingsSideBar(true);
    }

    const getGrade = (grade) => {
        if(grade != ""){
            if(grade == 'F'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade == 'D-'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade == 'D' || grade == 'D+'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade ==  'C-'|| grade == 'C' || grade == 'C+'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade == "B-" || grade == 'B' || grade == 'B+'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade == "A-"){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }else if(grade == 'A' || grade == 'A+' || grade == 'A++'){
                return (
                    <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                );
            }
        }else{
            return(
                <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom><CircularProgress size={24} /> </Typography> 
            );
        }      
    }
    const getLoaderColor = () => {
        if(activeBrief.report){
            const percentage = parseInt((wordCount/activeBrief.report.recommended_word_count) * 100);
            if(percentage < 35){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'rgb(255, 76, 76)',opacity:'.5'}}/>
                );
            }else if(percentage < 75){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#fb924a',opacity:'.5'}}/>
                );
            }else if(percentage > 75){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#28b32c',opacity:'.5'}}/>
                );
            }else{
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#334152',opacity:'.5'}}/>
                );
            }
        }else{
            return(
                <Chip size="small" label="" style={{color:'white',background:'#334152',opacity:'0'}}/>
            );
        }
    }

    const getProgressLoaderValues = (type,grade) => {
        if(topic_lodash.isEmpty(topics)){
            return "";
        }else if(type == "percentage"){
            const totalTopics = topics.length;
            let coveredTopic = 0;
            topics.map((singleTopic) => {
                if(singleTopic.covered){
                    coveredTopic++;
                }
            });
            const value = parseInt((coveredTopic/totalTopics)*100);
            if(value > 5){
                return value;
            }else{
                return 5;
            }
        }else if(type == "color"){
            if(grade != ""){
                if(grade == 'F'){
                        return '#ff4c4c';
                    }else if(grade == 'D-'){
                        return '#fd6f4b';
                    }else if(grade == 'D' || grade == 'D+'){
                        return '#005a87';
                    }else if(grade ==  'C-'|| grade == 'C' || grade == 'C+'){
                        return '#9c9c31'; 
                    }else if(grade == "B-" || grade == 'B' || grade == 'B+'){
                        return '#8FBC8F';
                    }else if(grade == "A-"){
                        return '#556B2F'; 
                    }else if(grade == 'A' || grade == 'A+' || grade == 'A++'){
                        return '#006400';
                    }
            }else{
                return "rgb(255, 76, 76)";
            }      
        }
    };

    const handleFinishMarkComplete = (data) => {
        dispatch(briefActions.getAdthriveBriefs());
        fetchReport();
    };

    const css = `
        .brief button[aria-pressed="true"] .MuiTypography-subtitle2{
            font-weight: bold !important;
        }
        .brief button[aria-pressed="false"] .MuiTypography-subtitle2{
            font-weight: normal !important;
        }
    `;

    return(
        <Grid container xs="12" md="12" direction="row" className="brief" style={{overflow: 'hidden'}}>
            <style>{css}</style>
            <Grid></Grid>
            <DashboardHeader goBack={true} TopicName={topicName} Briefs={props.Briefs} isNotLoggedIn={(location && location.state && location.state.isNotLoggedIn) ? true : false}/>
            <Grid xs="12" item style={{textAlign:'center',background:'rgb(249, 249, 249)'}} >
                 <Grid container xs="12" alignContent="center" justify="center"> 
                     <Grid item xs="8" style={{textAlign:'center'}}>
                     <Typography variant="caption" display="block" style={{fontWeight:'500',color:'#334152'}}>{BRIEFS_UTIL.CURRENT_GRADE_TEXT}</Typography>
                    {getGrade(grade)}
                     {(activeBrief && activeBrief.report) ?
                        <div style={{position: 'absolute', top: '97px',right: '75px',fontSize: '14px', display: 'none'}}>
                             <Typography variant="h4" style={{fontWeight:'800',color:'#567393'}}>{activeBrief.report.recommended_grade}</Typography>  
                            <div style={{height:'24px',width:'1px',borderLeft:'1px dashed',marginLeft: '14px'}}>
                            </div>
                        </div>
                        : null }
                        <Line percent={getProgressLoaderValues("percentage")} strokeWidth="7" trailWidth="7" strokeColor={getProgressLoaderValues("color",grade)} />
                     </Grid>
                 </Grid>
                 <Typography variant="subtitle2" display="block" style={{color:'#334152',marginBottom:'20px', fontSize: '12px'}}>Cover {nextGradeCount === 0 ? 1 : nextGradeCount} more topic{nextGradeCount <= 1 ? '' : 's'} to reach next grade</Typography>
                 <Typography variant="subtitle2" display="block" style={{color:'#334152'}}>{BRIEFS_UTIL.WORD_COUNT_TEXT} {getLoaderColor()}&nbsp;&nbsp;/&nbsp;&nbsp;{(activeBrief.report) ? activeBrief.report.recommended_word_count : 'loading..'}</Typography>
                    {loggedInState.isLoggedInAdthrive && <BriefCompletionButton Briefs={props.Briefs} updateContentCall={updateContentCall} handleFinishMarkComplete={handleFinishMarkComplete}/>}
             </Grid>
            <Grid item xs="12" style={{textAlign:'center',background:'rgb(249, 249, 249)', marginTop: '5px'}}>
                <Grid container spacing={2} direction="column" alignItems="center">
                    <Grid item>
                    
                        <ToggleButtonGroup value={viewState} exclusive onChange={(event,value) => {handleViewChange(value)}}>
                            <ToggleButton value="topic" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_TOPIC_TEXT}</Typography>
                            </ToggleButton>
                            <ToggleButton value="questions" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_QUESTIONS_TEXT}</Typography>
                            </ToggleButton>
                            <ToggleButton value="outlines" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_OUTLINES_TEXT}</Typography>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                </Grid>
            </Grid>
            {(viewState == "topic") ?
             <TopicBrief 
             showUnused={showUnused}
             setShowUnused={setShowUnused}
             viewHeadings={viewHeadings}
             topics={topics}
             topicName={topicName}
             setTopicClusteringSwitch={setTopicClusteringSwitch}
             topicClusteringSwitch={topicClusteringSwitch}
             topicClustering={topicClustering}
             clusteringLoadingState= {clusteringLoadingState}/>
            : null }
            {(viewState == "questions") ? 
                <QuestionsBrief 
                briefInfo={activeBrief}
                setQuestionsClusteringSwitch={setQuestionsClusteringSwitch}
                questionsClusteringSwitch={questionsClusteringSwitch}
                questionsClustering={questionsClustering}
                clusteringLoadingState={clusteringLoadingState}
                updateContentCall={updateContentCall}
                fetchReport={fetchReport}
                />
            :null}
            {(viewState == "outlines") ? 
                <OutlineBrief briefInfo={activeBrief}/>
            :null}
            <Drawer anchor="right" open={headingsSideBar} onClose={()=>setHeadingsSideBar(false)}>
                <TopicDetail topic={selectedTopic} close={() => setHeadingsSideBar(false)}/>
            </Drawer>
        </Grid>
    );

}

export default Brief;